/* globals window */

import trans from '../../../utils/trans';
import transChoice from '../../../utils/transChoice';

/**
 * Returns the workout status label
 * @param {Object} workout
 * @return {String}
 */
const getWorkoutStatusLabel = (workout) => {
  const { isLoggedIn } = window.appSettings;

  if (!workout.reservation_allowed) {
    if (isLoggedIn) {
      return trans('classes.statusFirstComeFirstServed_loggedIn');
    }

    return trans('classes.statusFirstComeFirstServed');
  }

  if (workout.reserved) {
    return trans('classes.statusBooked');
  }

  if (workout.waitlist) {
    return trans('classes.statusOnWaitingList');
  }

  if (!workout.spots_available) {
    if (isLoggedIn) {
      return trans('classes.statusHasWaitingList');
    }

    return transChoice('classes.statusNumSpotsBooked', workout.spots_booked, {
      numSpots: workout.spots_booked,
    });
  }

  if (workout.spots_booked) {
    const numBookedLabel = transChoice('classes.statusNumSpotsBooked', workout.spots_booked, {
      numSpots: workout.spots_booked,
    });

    if (isLoggedIn) {
      const numAvailableLabel = transChoice('classes.statusNumSpotsAvailable', workout.spots_available, {
        numSpots: workout.spots_available,
      });

      return `${numBookedLabel} | ${numAvailableLabel}`;
    }

    return `${numBookedLabel}`;
  }

  return transChoice('classes.statusNumSpotsAvailable', workout.spots_available, {
    numSpots: workout.spots_available,
  });
};

export default getWorkoutStatusLabel;



// WEBPACK FOOTER //
// ./resources/assets/js/specifics/inventoryOverview/utils/getWorkoutStatusLabel.js